module.exports = __webpack_public_path__ + "static/media/youtube.7e56c5b9.svg";